import { Input, Schema, Form, Button } from 'rsuite';
import TextField from '../../components/form/textfield';
import { useCallback, useRef, useState } from 'react';
import IconTextField from '../../components/form/icon-textfield';
import { Show, Hide } from 'react-iconly';
import { postSignIn } from '../../core';
import { showToast } from '../../utils/toast';
import { OTPStep } from './components/otp-step';
import { useNavigate } from 'react-router-dom';
// import Cookies from 'js-cookie';
import { useUser } from '../../contexts/user';

const { StringType } = Schema.Types;
const model = Schema.Model({
  mobile_number: StringType('فرمت شماره موبایل صحیح نیست.')
    .pattern(/09[0-9]{9}$/, 'شماره موبایل باید شامل صفر و یازده رقمی انگلیسی باشد.')
    .isRequired('شماره موبایل را وارد کنید.'),

  password: StringType('فرمت پسورد صحیح نیست.').isRequired('پسورد را وارد کنید.')
});
const forgetPassowrdModel = Schema.Model({
  mobile_number: StringType('فرمت شماره موبایل صحیح نیست.')
    .pattern(/09[0-9]{9}$/, 'شماره موبایل باید شامل صفر و یازده رقمی انگلیسی باشد.')
    .isRequired('شماره موبایل را وارد کنید.')
});

export const SignIn = () => {
  const { userTrigger, setUserTrigger } = useUser();
  const navigate = useNavigate();
  const [step, setStep] = useState<'signIn' | 'reset'>('signIn');
  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const formRef = useRef<any>(null);
  const [formError, setFormError] = useState({});
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [formValue, setFormValue] = useState<any>({});

  const handleSubmit = useCallback(async () => {
    if (formRef.current && !formRef.current.check()) {
      console.log('formError', formError);
      return;
    }
    console.log('submitted', formValue);
    // return;
    setLoading(true);
    try {
      const { data, status } = await postSignIn(formValue.mobile_number, formValue.password);
      if (status === 200) {
        if (data.state === 'error') {
          showToast(data.message, 'error');
        } else if (data.state === 'success') {
          localStorage.setItem('token', data.token);
          showToast(data.message, 'success');
          // todo: handle auth context
          setUserTrigger(!userTrigger);
          navigate('/feed');
          // set token
          // navigate to feeds
        } else {
          showToast('مشکلی پیش آمده', 'error');
        }
      } else {
        showToast('مشکلی پیش آمده', 'error');
      }
      console.log(data, status);
    } catch (e) {
      showToast('مشکلی پیش آمده', 'error');
      console.log(e);
    }
    setLoading(false);
  }, [formValue, formError, formRef]);

  const handleForgetPassword = () => {
    // console.log()
    const checkRes = forgetPassowrdModel.check({
      mobile_number: formValue.mobile_number
    });

    if (checkRes.mobile_number.hasError) {
      setFormError({ mobile_number: checkRes.mobile_number.errorMessage });
    } else {
      setStep('reset');
    }
  };

  return (
    <div className="pt-3 px-4">
      {step === 'signIn' ? (
        <>
          <h1 className="text-base text-center font-normal">
            برای ورود به حساب کاربریتان شماره تماس و رمز ورود خود را وارد کنید. یا اگر حساب کاربری
            ندارید بر روی گزینه &apos;ثبت نام&apos; بزنید و یک حساب کاربری در کمتر از یک دقیقه
            بسازید!
          </h1>
          <Form
            ref={formRef}
            onChange={setFormValue}
            onCheck={setFormError}
            formError={formError}
            model={model}
            onSubmit={handleSubmit}
            className="w-[90%] mx-auto pb-3">
            <TextField
              accepter={Input}
              type="number"
              name="mobile_number"
              label="شماره تماس"
              placeholder="09123456789"
              dir="ltr"
            />
            <IconTextField
              name="password"
              label="یک پسورد برای حسابتان وارد کنید"
              type={visible ? 'text' : 'password'}
              accepter={Input}
              dir="ltr"
              onIconCLick={() => setVisible(!visible)}
              eyeVisible={visible}
              onIcon={<Hide size="small" />}
              offIcon={<Show size="small" />}
            />
            <div className="flex justify-evenly">
              <Button
                appearance="primary"
                className="w-[30%] mt-5 btn-outline"
                type="submit"
                loading={loading}>
                ورود
              </Button>
              <Button
                appearance="subtle"
                className="w-[30%] mt-5 btn-outline"
                type="button"
                onClick={() => navigate('/auth/sign-up')}>
                ثبت نام
              </Button>
            </div>
            <div className="flex flex-row-reverse">
              <Button
                appearance="ghost"
                size="xs"
                className="no-shadow w-fit mt-5 !py-2 btn-outline !text-[--rs-pink] !text-basesm !border-[--rs-primary-200] mr-auto"
                type="button"
                onClick={handleForgetPassword}>
                رمز ورود خود را فراموش کرده اید؟
              </Button>
            </div>
          </Form>
        </>
      ) : (
        <OTPStep
          type="reset"
          userData={{ mobile_number: formValue.mobile_number, password: formValue.password }}
        />
      )}
    </div>
  );
};
